/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Table } from "react-bootstrap";
import CompletedJobListItem from "./CompletedJobListItem";
import JobLoadedItem from "./JobLoadedItem";

const CompletedJobList = ({ jobs, path }) => {
  const jobItems = jobs.map((job, index) => (
    <CompletedJobListItem
      key={`job-${job.id}`}
      index={index}
      job={job}
      path={path}
    />
  ));

  const jobLoadedItems = jobs.map((job, index) =>
    job.jobItems.map(loadedItem => (
      <JobLoadedItem
        key={`loadedItem-${loadedItem.id}`}
        index={index}
        job={job}
        loadedItem={loadedItem}
      />
    ))
  );

  return (
    <div>
      <h4>Jobs</h4>
      <Table bordered>
        <thead>
          <tr className="header">
            <td>Sequence</td>
            <td>Customer</td>
            <td>Category</td>
            <td>Status</td>
            <td>Start</td>
            <td>End</td>
            <td style={{ width: 50 }} />
          </tr>
        </thead>
        <tbody>{jobItems}</tbody>
      </Table>

      <h4>Items</h4>
      <Table bordered>
        <thead>
          <tr className="header">
            <td>Sequence</td>
            <td>Item</td>
            <td>Quantity</td>
            <td>Delivery Status</td>
          </tr>
        </thead>
        <tbody>{jobLoadedItems}</tbody>
      </Table>
    </div>
  );
};
CompletedJobList.propTypes = {
  jobs: PropTypes.array,
  path: PropTypes.string
};
CompletedJobList.defaultProps = {
  jobs: [],
  path: ""
};

export default CompletedJobList;



// WEBPACK FOOTER //
// ./src/components/jobs/CompletedJobList.js